(function (root) {
  var SPECIAL_REQUIRED = ['ガラスモザイク', '石材', '大形タイル壁', 'エコカラット'];
  var BEST = { '◎': 2, '○': 1 };

  function toList(v) {
    if (v == null || v === '') return [];
    if (Array.isArray(v)) return v;
    var s = String(v).trim();
    if (s.charAt(0) === '[') { try { return JSON.parse(s); } catch (e) {} }
    return [s];
  }

  function maxSide(size) {
    if (!size) return 0;
    var s = String(size).replace(/[０-９．]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 65248); });
    var nums = (s.match(/\d+(?:\.\d+)?/g) || []).map(Number).filter(function (n) { return n >= 10 && n <= 6000; });
    return nums.length ? Math.max.apply(null, nums) : 0;
  }

  function classifyTile(t) {
    var types = [];
    var fmt = toList(t.format).join(' ');
    var cat = toList(t.cat3).join(' ');
    var text = [t.title, cat, fmt, t.vendor].join(' ');
    var mat = String(t.material || '');
    if (/ガラス/.test(mat)) types.push('ガラスモザイク');
    if (/天然石/.test(mat)) types.push('石材');
    if (/エコカラット/.test(text)) types.push('エコカラット');
    if (/れんが/.test(mat) || /ブリック|スライスレンガ/.test(cat)) types.push('ブリックタイル');
    var side = maxSide(t.size);
    if (/モザイク/.test(fmt) || (side > 0 && side <= 50)) types.push('モザイクタイル');
    if (/大判/.test(fmt) || (side >= 590 && !/モザイク/.test(fmt))) types.push('大形タイル壁');
    return types;
  }

  function placesFor(data, uses) {
    uses = toList(uses);
    return data.places.filter(function (p) {
      return p.uses.some(function (u) { return uses.indexOf(u) !== -1; });
    });
  }

  function hasAll(list, need) {
    return need.every(function (n) { return list.indexOf(n) !== -1; });
  }

  function rank(a, b) {
    return (b.oem - a.oem) || ((BEST[b.best] || 0) - (BEST[a.best] || 0)) || (b.pop - a.pop) || a.name.localeCompare(b.name, 'ja');
  }

  function tileOk(item, types) {
    if (types.some(function (t) { return item.ng.indexOf(t) !== -1; })) return false;
    return true;
  }

  function adhesives(data, place, sub, types) {
    return data.adhesives.filter(function (a) {
      if (!hasAll(a.areas, place.areas)) return false;
      if (sub && a.subs.indexOf(sub) === -1) return false;
      if (!tileOk(a, types)) return false;
      if (types.indexOf('エコカラット') !== -1) return a.tiles.indexOf('エコカラット') !== -1;
      for (var i = 0; i < SPECIAL_REQUIRED.length; i++) {
        var s = SPECIAL_REQUIRED[i];
        if (s === '大形タイル壁' && place.floor) continue;
        if (types.indexOf(s) !== -1 && a.tiles.indexOf(s) === -1) return false;
      }
      if (a.only && types.indexOf(a.only) === -1) return false;
      return true;
    }).sort(rank);
  }

  function grouts(data, place, types) {
    return data.grouts.filter(function (g) {
      return hasAll(g.areas, place.areas) && tileOk(g, types);
    }).sort(rank);
  }

  function subsFor(data, place, types) {
    var seen = {};
    adhesives(data, place, null, types).forEach(function (a) { a.subs.forEach(function (s) { seen[s] = 1; }); });
    return data.subOrder.filter(function (s) { return seen[s]; });
  }

  function cellKey(placeKey, sub, types) {
    return placeKey + '|' + (sub || 'わからない') + '|' + (types.slice().sort().join('+') || '一般');
  }

  var LIMITS = {
    'MT-BOND-FLEX': function (side) { return side > 0 && side <= 300; },
    'タイルエースPro': function (side, types) { return side > 0 && side <= 600 && types.indexOf('石材') === -1; }
  };

  function approved(data, place, sub, types, side) {
    var cell = data.approved && data.approved[cellKey(place.key, sub, types)];
    if (!cell) return null;
    function pick(list, names) {
      return names.map(function (n) {
        return list.filter(function (x) { return x.name === n; })[0];
      }).filter(function (x) { return x && (!LIMITS[x.name] || LIMITS[x.name](side, types)); });
    }
    var a = pick(data.adhesives, cell.a), g = pick(data.grouts, cell.g);
    return a.length && g.length ? { adhesives: a, grouts: g } : null;
  }

  function approvedSubs(data, place, types, side) {
    return data.subOrder.filter(function (s) { return approved(data, place, s, types, side); });
  }

  function tileDims(size, thickness, types, format) {
    if (!size || /[〜～~]/.test(size)) return null;
    if (types.indexOf('モザイクタイル') !== -1 || /異形|モザイク/.test(String(format || ''))) return null;
    var s = String(size).replace(/[０-９．]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 65248); });
    var m = s.match(/(\d+(?:\.\d+)?)\s*[×xX＊*]\s*(\d+(?:\.\d+)?)(?:\s*[×xX＊*]\s*(\d+(?:\.\d+)?))?/);
    if (!m) return null;
    var t = thick(thickness) || (m[3] ? +m[3] : 0);
    if (!(+m[1] > 0 && +m[2] > 0 && t > 0)) return null;
    return { a: +m[1], b: +m[2], t: t };
  }

  function thick(v) {
    var s = String(toList(v)[0] || '').replace(/[０-９．]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 65248); }).trim();
    var m = s.match(/^約?\s*(\d+(?:\.\d+)?)\s*(?:[〜～~]\s*(\d+(?:\.\d+)?))?\s*mm$/);
    return m ? +(m[2] || m[1]) : 0;
  }

  function groutUsage(item, dims, width) {
    var j = item.joint;
    if (!j || !dims || !(width > 0)) return null;
    var a = dims.a + width, b = dims.b + width;
    if (j.coef) return dims.t * width * (1 / a + 1 / b) * j.coef;
    if (j.mt) return 1e6 * width * dims.t * (dims.a + dims.b) / (a * b) * 25 / (4.5 * 2818800);
    return null;
  }

  function packs(product, area, usage) {
    usage = usage === undefined ? product.usage : usage;
    if (!product.packKg || !usage || !(area > 0)) return null;
    var kg = usage * area;
    return { kg: Math.round(kg * 10) / 10, qty: Math.max(1, Math.ceil(kg / product.packKg)) };
  }

  var api = { classifyTile: classifyTile, placesFor: placesFor, adhesives: adhesives, grouts: grouts, subsFor: subsFor, tileDims: tileDims, groutUsage: groutUsage, cellKey: cellKey, approved: approved, approvedSubs: approvedSubs, packs: packs, maxSide: maxSide, toList: toList };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.PairingEngine = api;
})(this);
